import React from 'react';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toast } from 'primereact/toast';
import '../components/toast.css' 

  const showToastMessage = (msg, info) => {
 switch(info){
  case 'success':
 toast.success(msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
  hideProgressBar: true, // Snackbars don't use progress bars
  closeButton: false,    // Removes the 'X' button
        });
  break
  case 'info':
 toast.info(msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
  hideProgressBar: true, // Snackbars don't use progress bars
  closeButton: false,    // Removes the 'X' button
        });
  break
  case 'warning':
 toast.warning(msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
  hideProgressBar: true, // Snackbars don't use progress bars
  closeButton: false,    // Removes the 'X' button
        });
  break
  case 'error':
 toast.error(msg, {
         
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
  hideProgressBar: true, // Snackbars don't use progress bars
  closeButton: false,    // Removes the 'X' button
        });
  break
 }
       
    };
  
export default showToastMessage
/**
 *  const showToastMessage = (msg, info) => {
  const toastOptions = {
    position: toast.POSITION.TOP_RIGHT,
  };

  // Ensure the type exists in toast, fallback to generic info if invalid
  const toastMethod = Snackbar[info] ? Snackbar[info] : Snackbar.info;
  
  toastMethod(msg, toastOptions);
};
 */